/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 25.01.13, 13:06
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { IBasicGGSTextField } from "../IBasicGGSTextField";
import { GGSTextFieldSignal } from "./GGSTextFieldSignal";

export class HTMLLinkClickSignal extends GGSTextFieldSignal {
    public static HTML_LINK_CLICK: string = "htmlLinkClick";

    constructor() {
        super();
        this.mappedEventType = HTMLLinkClickSignal.HTML_LINK_CLICK;
    }

    public dispatchTyped(basicTextField: IBasicGGSTextField, linkId: string): void {
        super.dispatch(basicTextField, linkId);
    }
}
